import { useState, useEffect, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { 
  Calendar, Clock, MapPin, Heart, MessageCircle, Moon, Star,
  Target, TrendingUp, Gift, Sparkles
} from 'lucide-react';
import { Button } from '../components/ui/button';
import SectionHeading from '../components/SectionHeading';
import LaserBorder from '../components/LaserBorder';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Ramadan 1447 AH Schedule - with full date for filtering
const ramadanSchedule = [
  { date: 'Feb 17', fullDate: '2026-02-17', day: 'Tue', program: 'Isha & Taraweeh', time: '7:30 PM', type: 'taraweeh' },
  { date: 'Feb 18', fullDate: '2026-02-18', day: 'Wed', program: 'Isha & Taraweeh', time: '7:30 PM', type: 'taraweeh' },
  { date: 'Feb 19', fullDate: '2026-02-19', day: 'Thu', program: 'Isha & Taraweeh', time: '7:30 PM', type: 'taraweeh' },
  { date: 'Feb 20', fullDate: '2026-02-20', day: 'Fri', program: 'Hall Unavailable', time: '-', type: 'unavailable' },
  { date: 'Feb 21', fullDate: '2026-02-21', day: 'Sat', program: 'Iftar / Maghrib', time: '5:56 PM', type: 'iftar' },
  { date: 'Feb 22', fullDate: '2026-02-22', day: 'Sun', program: 'Isha & Taraweeh', time: '7:30 PM', type: 'taraweeh' },
  { date: 'Feb 23', fullDate: '2026-02-23', day: 'Mon', program: 'Isha & Taraweeh', time: '7:30 PM', type: 'taraweeh' },
  { date: 'Feb 24', fullDate: '2026-02-24', day: 'Tue', program: 'Isha & Taraweeh', time: '7:30 PM', type: 'taraweeh' },
  { date: 'Feb 25', fullDate: '2026-02-25', day: 'Wed', program: 'Isha & Taraweeh', time: '7:30 PM', type: 'taraweeh' },
  { date: 'Feb 26', fullDate: '2026-02-26', day: 'Thu', program: 'Isha & Taraweeh', time: '7:30 PM', type: 'taraweeh' },
  { date: 'Feb 27', fullDate: '2026-02-27', day: 'Fri', program: 'Hall Unavailable', time: '-', type: 'unavailable' },
  { date: 'Feb 28', fullDate: '2026-02-28', day: 'Sat', program: 'Iftar / Maghrib', time: '6:06 PM', type: 'iftar' },
  { date: 'Mar 01', fullDate: '2026-03-01', day: 'Sun', program: 'Isha & Taraweeh', time: '7:30 PM', type: 'taraweeh' },
  { date: 'Mar 02', fullDate: '2026-03-02', day: 'Mon', program: 'Isha & Taraweeh', time: '7:45 PM', type: 'taraweeh' },
  { date: 'Mar 03', fullDate: '2026-03-03', day: 'Tue', program: 'Isha & Taraweeh', time: '7:45 PM', type: 'taraweeh' },
  { date: 'Mar 04', fullDate: '2026-03-04', day: 'Wed', program: 'Isha & Taraweeh', time: '7:45 PM', type: 'taraweeh' },
  { date: 'Mar 05', fullDate: '2026-03-05', day: 'Thu', program: 'Isha & Taraweeh', time: '7:45 PM', type: 'taraweeh' },
  { date: 'Mar 06', fullDate: '2026-03-06', day: 'Fri', program: 'Hall Unavailable', time: '-', type: 'unavailable' },
  { date: 'Mar 07', fullDate: '2026-03-07', day: 'Sat', program: 'Hall Unavailable', time: '-', type: 'unavailable' },
  { date: 'Mar 08', fullDate: '2026-03-08', day: 'Sun', program: 'Iftar / Maghrib (DST Starts)', time: '7:16 PM', type: 'iftar' },
  { date: 'Mar 09', fullDate: '2026-03-09', day: 'Mon', program: 'Isha 8:45 PM & Taraweeh', time: '9:00 PM', type: 'taraweeh' },
  { date: 'Mar 10', fullDate: '2026-03-10', day: 'Tue', program: 'Isha 8:45 PM & Taraweeh', time: '9:00 PM', type: 'taraweeh' },
  { date: 'Mar 11', fullDate: '2026-03-11', day: 'Wed', program: 'Isha 8:45 PM & Taraweeh', time: '9:00 PM', type: 'taraweeh' },
  { date: 'Mar 12', fullDate: '2026-03-12', day: 'Thu', program: 'Isha 8:45 PM & Taraweeh', time: '9:00 PM', type: 'taraweeh' },
  { date: 'Mar 13', fullDate: '2026-03-13', day: 'Fri', program: 'Hall Unavailable for Taraweeh, Jummah Available', time: '-', type: 'unavailable' },
  { date: 'Mar 14', fullDate: '2026-03-14', day: 'Sat', program: 'Iftar / Maghrib + Fundraising Night', time: '7:24 PM', type: 'iftar' },
  { date: 'Mar 15', fullDate: '2026-03-15', day: 'Sun', program: 'Isha 9:00 PM & Taraweeh', time: '9:15 PM', type: 'taraweeh' },
  { date: 'Mar 16', fullDate: '2026-03-16', day: 'Mon', program: 'Isha 9:00 PM & Taraweeh', time: '9:15 PM', type: 'taraweeh' },
  { date: 'Mar 17', fullDate: '2026-03-17', day: 'Tue', program: 'Isha 9:00 PM & Taraweeh', time: '9:15 PM', type: 'taraweeh' },
  { date: 'Mar 18', fullDate: '2026-03-18', day: 'Wed', program: 'Isha 9:00 PM & Taraweeh', time: '9:15 PM', type: 'taraweeh' },
  { date: 'Mar 19', fullDate: '2026-03-19', day: 'Thu', program: 'Isha 9:00 PM & Taraweeh', time: '9:15 PM', type: 'taraweeh' },
];

// Helper function to filter upcoming events in EST timezone
const getUpcomingEvents = (events) => {
  // Get current date in EST timezone
  const now = new Date();
  const estOffset = -5 * 60; // EST is UTC-5
  const utcTime = now.getTime() + (now.getTimezoneOffset() * 60000);
  const estTime = new Date(utcTime + (estOffset * 60000));
  const todayEST = estTime.toISOString().split('T')[0];
  
  return events.filter(event => {
    return event.fullDate >= todayEST;
  });
};

// Get today's date in EST
const getTodayEST = () => {
  const now = new Date();
  const estOffset = -5 * 60;
  const utcTime = now.getTime() + (now.getTimezoneOffset() * 60000);
  const estTime = new Date(utcTime + (estOffset * 60000));
  return estTime.toISOString().split('T')[0];
};

const RAMADAN_GOAL = 6000;

const RamadanPage = () => {
  const [ramadanDonations, setRamadanDonations] = useState(0);
  const [previousDonations, setPreviousDonations] = useState(0);
  const [loading, setLoading] = useState(true);
  const [showCelebration, setShowCelebration] = useState(false);

  // Cash donations received offline (this is the TOTAL amount raised)
  const TOTAL_RAISED = 2210;

  // Google Ads conversion tracking for Ramadan page
  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', {'send_to': 'AW-17995864647/KYMcCL_isIQcEMe0jIVD'});
    }
  }, []);

  const fetchRamadanDonations = useCallback(async () => {
    try {
      // Set the total raised amount directly
      const newTotal = TOTAL_RAISED;
      
      // Check if donations increased
      if (newTotal > ramadanDonations && ramadanDonations > 0) {
        setShowCelebration(true);
        setTimeout(() => setShowCelebration(false), 3000);
      }
      
      setPreviousDonations(ramadanDonations);
      setRamadanDonations(newTotal);
    } catch (error) {
      setRamadanDonations(TOTAL_RAISED);
    } finally {
      setLoading(false);
    }
  }, [ramadanDonations]);

  useEffect(() => {
    fetchRamadanDonations();
    
    // Auto-refresh every 30 seconds to show live updates
    const interval = setInterval(fetchRamadanDonations, 30000);
    return () => clearInterval(interval);
  }, [fetchRamadanDonations]);

  const progressPercentage = Math.min((ramadanDonations / RAMADAN_GOAL) * 100, 100);

  const getRowStyle = (type) => {
    switch (type) {
      case 'iftar':
        return 'bg-orange-500/10 border-l-4 border-orange-500';
      case 'unavailable':
        return 'bg-muted/30 text-muted-foreground';
      default:
        return 'bg-card hover:bg-primary/5';
    }
  };

  return (
    <div className="min-h-screen pt-24">
      {/* Hero */}
      <section className="py-16 lg:py-24 hero-gradient islamic-pattern relative overflow-hidden">
        <div className="absolute top-10 right-10 opacity-20">
          <Moon className="w-32 h-32 text-secondary" />
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-3xl"
          >
            <span className="inline-block px-4 py-1 rounded-full bg-secondary/20 text-secondary text-sm font-medium mb-4">
              Ramadan 1447 AH
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground font-['Outfit'] leading-tight mb-6">
              Ramadan <span className="text-gradient">Program Schedule</span>
            </h1>
            <p className="text-lg text-muted-foreground leading-relaxed">
              February 17 – March 18, 2026. Join us for Taraweeh prayers and community Iftars.
              May Allah accept our fasting and prayers. Ameen.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Fundraising Progress - Progress Bar */}
      <section className="py-16 bg-card border-y border-border" data-testid="ramadan-fundraising">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl mx-auto text-center">
            <h3 className="text-2xl font-bold font-['Outfit'] text-foreground mb-2">Ramadan Expenses Goal</h3>
            <p className="text-muted-foreground mb-8">Help us cover Iftar & program costs</p>

            {/* Progress Bar */}
            <div className="relative mb-6">
              {/* Celebration sparkles when donation received */}
              <AnimatePresence>
                {showCelebration && (
                  <>
                    {[...Array(8)].map((_, i) => (
                      <motion.div
                        key={i}
                        initial={{ opacity: 1, scale: 0, y: 0 }}
                        animate={{ opacity: 0, scale: 1, y: -50 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.8, delay: i * 0.1 }}
                        className="absolute pointer-events-none"
                        style={{ left: `${10 + i * 12}%`, top: '-20px', zIndex: 10 }}
                      >
                        <Sparkles className="w-5 h-5 text-yellow-400" />
                      </motion.div>
                    ))}
                  </>
                )}
              </AnimatePresence>

              {/* Background bar */}
              <div className="w-full h-8 rounded-full bg-muted/50 overflow-hidden relative">
                {/* Progress fill */}
                <motion.div
                  initial={{ width: 0 }}
                  animate={{ width: `${progressPercentage}%` }}
                  transition={{ duration: 1.5, ease: "easeOut" }}
                  className="h-full rounded-full relative overflow-hidden"
                  style={{
                    background: 'linear-gradient(90deg, #22c55e 0%, #16a34a 50%, #15803d 100%)'
                  }}
                >
                  {/* Shimmer effect */}
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent animate-shimmer" />
                </motion.div>
                
                {/* Percentage on the bar */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="text-sm font-bold text-white drop-shadow-md">
                    {progressPercentage.toFixed(0)}%
                  </span>
                </div>
              </div>

              {/* Amount labels below bar */}
              <div className="flex justify-between mt-2 text-sm">
                <span className="text-muted-foreground">$0</span>
                <span className="text-muted-foreground">${RAMADAN_GOAL.toLocaleString()}</span>
              </div>
            </div>

            {/* Amount Display */}
            <div className="flex items-center justify-center gap-8 mb-8">
              <div className="text-center">
                <motion.p 
                  className="text-3xl font-bold text-green-500 font-['Outfit']"
                  key={ramadanDonations}
                  initial={{ scale: 1 }}
                  animate={{ scale: [1, 1.1, 1] }}
                  transition={{ duration: 0.3 }}
                >
                  ${ramadanDonations.toLocaleString()}
                </motion.p>
                <p className="text-sm text-muted-foreground">Raised</p>
              </div>
              <div className="w-px h-12 bg-border" />
              <div className="text-center">
                <p className="text-3xl font-bold text-foreground font-['Outfit']">
                  ${RAMADAN_GOAL.toLocaleString()}
                </p>
                <p className="text-sm text-muted-foreground">Goal</p>
              </div>
            </div>

            {/* Live update indicator */}
            <div className="flex items-center justify-center gap-2 mb-6 text-sm text-muted-foreground">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
              </span>
              <span>Live updates</span>
            </div>

            <Link to="/donate?category=ramadan" data-testid="ramadan-donate-btn">
              <Button size="lg" className="rounded-full bg-green-600 hover:bg-green-700 text-white px-10 h-14 text-lg font-semibold shadow-lg">
                <Gift className="mr-2 h-5 w-5" />
                Donate to Ramadan Fund
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Schedule Table */}
      <section className="py-16 lg:py-24" data-testid="ramadan-schedule">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeading
            badge="Upcoming Events"
            title="Program Calendar"
            description="All programs held at 54 St. Paul Crescent, Barrie"
          />

          {/* Legend */}
          <div className="flex flex-wrap justify-center gap-4 mb-8">
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 rounded bg-primary/20 border-l-4 border-primary" />
              <span className="text-sm text-muted-foreground">Taraweeh</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 rounded bg-orange-500/20 border-l-4 border-orange-500" />
              <span className="text-sm text-muted-foreground">Community Iftar</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 rounded bg-muted/50" />
              <span className="text-sm text-muted-foreground">Hall Unavailable</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 rounded bg-green-500/20 border-l-4 border-green-500" />
              <span className="text-sm text-muted-foreground">Today</span>
            </div>
          </div>

          {/* Table */}
          <div className="overflow-x-auto">
            {(() => {
              const upcomingEvents = getUpcomingEvents(ramadanSchedule);
              const today = getTodayEST();
              
              if (upcomingEvents.length === 0) {
                return (
                  <div className="text-center py-12 bg-card rounded-2xl border border-border">
                    <Moon className="h-16 w-16 text-muted-foreground mx-auto mb-4 opacity-50" />
                    <h3 className="text-xl font-semibold text-foreground mb-2">Ramadan Program Completed</h3>
                    <p className="text-muted-foreground">All scheduled events have passed. JazakAllah Khair for joining us!</p>
                  </div>
                );
              }
              
              return (
                <table className="w-full border-collapse">
                  <thead>
                    <tr className="bg-muted/50">
                      <th className="px-4 py-3 text-left text-sm font-semibold text-foreground border-b border-border">Date</th>
                      <th className="px-4 py-3 text-left text-sm font-semibold text-foreground border-b border-border">Day</th>
                      <th className="px-4 py-3 text-left text-sm font-semibold text-foreground border-b border-border">Program</th>
                      <th className="px-4 py-3 text-left text-sm font-semibold text-foreground border-b border-border">Time (EST)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {upcomingEvents.map((item, index) => {
                      const isToday = item.fullDate === today;
                      const rowStyle = isToday 
                        ? 'bg-green-500/10 border-l-4 border-green-500' 
                        : getRowStyle(item.type);
                      
                      return (
                        <motion.tr
                          key={index}
                          initial={{ opacity: 0, x: -20 }}
                          whileInView={{ opacity: 1, x: 0 }}
                          viewport={{ once: true }}
                          transition={{ delay: index * 0.02 }}
                          className={`${rowStyle} transition-colors border-b border-border`}
                        >
                          <td className="px-4 py-3 text-sm font-medium">
                            {item.date}
                            {isToday && (
                              <span className="ml-2 px-2 py-0.5 text-xs font-semibold bg-green-500 text-white rounded-full">
                                TODAY
                              </span>
                            )}
                          </td>
                          <td className="px-4 py-3 text-sm">{item.day}</td>
                          <td className="px-4 py-3 text-sm">
                            {item.type === 'iftar' && <span className="inline-block w-2 h-2 rounded-full bg-orange-500 mr-2" />}
                            {item.type === 'taraweeh' && <span className="inline-block w-2 h-2 rounded-full bg-primary mr-2" />}
                            {item.program}
                          </td>
                          <td className="px-4 py-3 text-sm font-mono">{item.time}</td>
                        </motion.tr>
                      );
                    })}
                  </tbody>
                </table>
              );
            })()}
          </div>
          
          {/* Events count */}
          <p className="text-center text-sm text-muted-foreground mt-4">
            Showing {getUpcomingEvents(ramadanSchedule).length} upcoming events
          </p>
        </div>
      </section>

      {/* Location & Info */}
      <section className="py-16 lg:py-24 bg-card islamic-pattern" data-testid="ramadan-info">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <LaserBorder>
              <div className="p-8 space-y-6">
                <div className="flex items-center gap-3">
                  <div className="p-3 rounded-xl bg-primary/10">
                    <MapPin className="h-6 w-6 text-primary" />
                  </div>
                  <h3 className="text-xl font-semibold font-['Outfit'] text-foreground">Location</h3>
                </div>
                <div className="space-y-2">
                  <p className="font-medium text-foreground">54 St. Paul Crescent</p>
                  <p className="text-muted-foreground">Barrie, ON L9J 0M2</p>
                </div>
                <a 
                  href="https://maps.google.com/?q=54+St+Paul+Crescent+Barrie+ON"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button variant="outline" className="w-full rounded-xl">
                    Get Directions
                  </Button>
                </a>
              </div>
            </LaserBorder>

            <LaserBorder>
              <div className="p-8 space-y-6">
                <div className="flex items-center gap-3">
                  <div className="p-3 rounded-xl bg-green-500/10">
                    <MessageCircle className="h-6 w-6 text-green-500" />
                  </div>
                  <h3 className="text-xl font-semibold font-['Outfit'] text-foreground">Stay Updated</h3>
                </div>
                <p className="text-muted-foreground">
                  Join our WhatsApp group for real-time updates on prayer times and program changes.
                </p>
                <a 
                  href="https://chat.whatsapp.com/BZpW0tw4MUuLAVuZmzBRDU?mode=gi_t"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button className="w-full rounded-xl bg-green-500 hover:bg-green-600 text-white">
                    <MessageCircle className="mr-2 h-4 w-4" />
                    Join WhatsApp Group
                  </Button>
                </a>
              </div>
            </LaserBorder>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 lg:py-24" data-testid="ramadan-cta">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <SectionHeading
            badge="Support Ramadan"
            title="Help Us Reach Our Goal"
            description="Your donations help cover Iftar meals, facility costs, and program expenses during Ramadan."
          />
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/donate?category=ramadan">
              <Button size="lg" className="rounded-full bg-secondary text-secondary-foreground hover:bg-secondary/90 px-8 glow-gold">
                <Heart className="mr-2 h-5 w-5" />
                Donate Now
              </Button>
            </Link>
            <Link to="/volunteer">
              <Button size="lg" variant="outline" className="rounded-full px-8">
                Volunteer for Ramadan
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RamadanPage;
